import type { ReactNode } from 'react';

interface SectionToolbarProps {
  actions?: ReactNode;
  title: string;
}

/**
 * SectionToolbar - Bar with section title on the left and actions slot on the right.
 *
 * Responsive: stacks vertically on mobile (title on top, actions below, full-width),
 * single row on tablet and desktop.
 */
export const SectionToolbar = ({ actions, title }: SectionToolbarProps) => {
  return (
    <div className="flex flex-col md:flex-row md:items-center gap-3 md:gap-6 w-full">
      <div className="flex-1">
        <h2 className="text-xl font-semibold text-foreground">{title}</h2>
      </div>
      {actions && <div className="flex items-center gap-3 w-full md:w-auto">{actions}</div>}
    </div>
  );
};
